/**
 * Configuration mapping for R2 storage buckets used across the application.
 * Each key represents a logical bucket name that maps to the actual bucket identifier.
 */
export const BUCKETS = {
  /** Development media bucket for testing and staging */
  'media-dev': 'media-dev',
  /** Production media bucket (previously bridebook-img on S3) */
  media: 'media',
  /** Production files bucket for document storage */
  'bridebook-files': 'bridebook-files',
  /** Development files bucket for testing document storage */
  'bridebook-files-dev': 'bridebook-files-dev',
  /** User-generated images bucket. Used mainly in Scrapbook notes */
  'bb-user-images': 'bb-user-images',
  /** User profile and related images bucket */
  'users-imgs': 'users-imgs',
} as const;

type BucketKey = keyof typeof BUCKETS;

/**
 * Generates a public CDN URL for accessing files in a specific R2 bucket.
 *
 * @param bucket - The bucket key to generate a URL for
 * @returns The full public URL for the specified bucket
 */
export const getR2PublicPath = (bucket: BucketKey): string =>
  `https://${BUCKETS[bucket]}.bridebook.com`;
